import { atom } from 'jotai';

export const redirectAtom = atom<string>();
